export const localDay = (date: Date) =>
	`${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
export const moveDays = (date: string, days: number) => {
	const result = new Date(`${date}T12:00:00`);
	result.setDate(result.getDate() + days);
	return localDay(result);
};
export const getISOWeekNumber = (date: Date): number => {
	const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
	d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
	const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
	return Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
};
export const getMonthDays = (year: number, month: number) => {
	const first = new Date(year, month, 1, 12);
	const offset = (first.getDay() + 6) % 7;
	const count = Math.ceil((offset + new Date(year, month + 1, 0).getDate()) / 7) * 7;
	return Array.from({ length: count }, (_, i) => {
		const date = new Date(year, month, 1 - offset + i, 12);
		return { date, dateStr: localDay(date), isCurrentMonth: date.getMonth() === month };
	});
};
export const getMonthRange = (month: string) => {
	const date = new Date(`${month}-01T12:00:00`);
	const days = getMonthDays(date.getFullYear(), date.getMonth());
	return { from: days[0].dateStr, to: moveDays(days[days.length - 1].dateStr, 1) };
};
